export default {
    titleQuestion: "Kako Vam možemo pomoći?",
    titleDescription: "Postavite pitanje ili opišite problem koji imate",
    searchFaq: "Pretražite",
    categories: "Kategorije",
    searchResults: "Rezultati pretrage"
}
